module.exports = __webpack_public_path__ + "img/location-ndsm.4211653a.jpg";